<p-fieldset [legend]="topBarTrainingTitle" [toggleable]="true">
    <app-stat-card [cardList]="userHomeTrainingData.trainingCards">
        <ng-template #statCard let-singleCard>
          <div class="col-12 md:col-6 lg:col-3 training-card-padding">
          <app-stat-card-data [singleCard]="singleCard"></app-stat-card-data>
          </div>
        </ng-template>
      </app-stat-card>
</p-fieldset>
